import { type PropsWithChildren } from 'react'
import useUnsavedUploadsWarning from 'hooks/useUnsavedUploadsWarning'
import { usePhotoBankStore } from 'stores/RootStoreProvider'
import { observer } from 'mobx-react'

export default observer(function ProtectUnsavedPhotoUploads({
  children,
}: PropsWithChildren) {
  const photoBankStore = usePhotoBankStore()

  useUnsavedUploadsWarning({
    hasPendingUploads: photoBankStore.hasPendingUploads,
  })

  return <>{children}</>
})
